import React from "react";

// Inline SVG caret so the control needs no icon library and no MUI.
const CARET =
  "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 24 24' fill='none' stroke='%236B7280' stroke-width='2'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E\")";

/** Native select styled from theme tokens. */
export default function SelectInput({
  label,
  name,
  value,
  onChange,
  options = [],
  placeholder = "Select…",
  required = false,
  disabled = false,
  className = "",
}) {
  return (
    <div className={`w-full ${className}`}>
      {label && (
        <label
          htmlFor={name}
          className="block text-[10px] font-semibold uppercase tracking-[0.4px] text-ui-text-muted mb-1.5"
        >
          {label}
          {required && <span className="ml-0.5 text-state-danger">*</span>}
        </label>
      )}

      <select
        id={name}
        name={name}
        value={value ?? ""}
        onChange={onChange}
        required={required}
        disabled={disabled}
        style={{
          appearance: "none",
          backgroundImage: CARET,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "right 10px center",
        }}
        className="w-full cursor-pointer rounded-md border border-ui-border bg-ui-surface py-[7px] pl-[11px] pr-7 text-xs text-ui-text outline-none transition-colors focus:border-brand disabled:cursor-not-allowed disabled:opacity-60"
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options.map((o) => {
          const val = typeof o === "object" ? o.value : o;
          const text = typeof o === "object" ? o.label : o;
          return (
            <option key={val} value={val}>
              {text}
            </option>
          );
        })}
      </select>
    </div>
  );
}
